"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerMonthName = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
var _typography = require("../../../typography");
const DatePickerMonthName = (0, _styled.default)(_typography.TypeRampV2)`
    flex: 1 1 auto;
    margin-left: ${_designTokens.space.space20};
`;
exports.DatePickerMonthName = DatePickerMonthName;
//# sourceMappingURL=DatePickerMonthName.js.map